export default {
      id: "i-diploma-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/sprite.svg#i-diploma",
      toString: function () {
        return this.url;
      }
    }